import React, {useEffect} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles';
import Calendar2 from '../../../src/components/Calendar/Calendar2.js';
import DialogClose from '../../../src/util/DialogClose.js';
import {makeStyles} from '@material-ui/core/styles';
import {addressimage, addressimagehomessize, deletereserve, listreserve} from "../../api/api";
import {blue, green, purple} from "@material-ui/core/colors";
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';

const useStyles = makeStyles((theme) => ({
    root: {
        fontFamily: 'iransans',
        padding: '20px 10px',
        '& .MuiTextField-root': {
            width: '100%',
            fontFamily: 'iransans',
        },
        '& .MuiAlert-message': {

            fontFamily: 'iransans',
        },


        '& .MuiFormHelperText-root': {

            fontFamily: 'iransans',
            marginTop: 5,
            marginLeft: 0


        },


        '& .MuiTypography-root': {

            fontFamily: 'iransans',
        },

        '& .MuiListItemText-secondary': {

            fontFamily: 'iransans',
            marginTop: 10,
        },

        '& .MuiTypography-body1': {

            fontFamily: 'iransans',

        },


        '& .MuiTypography-h6': {

            fontFamily: 'iransans',

        },
        '& .MuiButton-root': {

            fontFamily: 'iransans',

        },
        '& .MuiTypography-colorTextSecondary': {
            color: '#222'
        }
        // '& .MuiListItem-button': {
        //
        //     fontFamily: 'iransans',
        //    border:'1px solid #dadada',
        //   borderRadius: 4,
        //
        // },

    },

    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    red: {

        color: '#f44336',


    },

    underlinetext: {

        fontSize: '0.75rem',
        marginTop: 5,
        color: '#f44336',
        fontFamily: 'iransans',


    },


    borderred: {
        fontFamily: 'iransans',
        border: '1px solid #f44336',
        borderRadius: 4,
        fontSize: 5,


    },
    border: {
        fontFamily: 'iransans',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 4,
        fontSize: 5,
        marginBottom: 0,
        color: 'rgba(0, 0, 0, 0.54)'

    },

    paper: {
        width: '80%',
        maxHeight: 435,
    },

    sendpic: {
        margin: '0 auto',
        marginBottom: 15,
        textAlign: 'center',
        '&:hover': {
            cursor: 'pointer',
        },
    },

    button: {
        fontSize: 18,
        fontWeight: 'bold',
        height: 43,
        width: '100%',
        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: '#3f51b5',
        '&:hover': {
            backgroundColor: '#172b95',
        },
    },

    input2: {
        fontFamily: 'iransans',
        width: '100%'
    },
    input: {
        fontFamily: 'iransans',
        width: '100%',
        marginTop: 15
    },
    formControl: {
        fontFamily: 'iransans',
        width: '100%',
        marginBottom: 15,

    },

    wrapper: {
        marginTop: 15,
        position: 'relative',
    },
    buttonSuccess: {
        fontSize: 18,
        fontWeight: 'bold',
        height: 43,
        width: '100%',

        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },

    iconButton: {
        padding: 10,
        fontSize: 15,
        fontFamily: 'iransans'
    },
    divider: {
        height: 28,
        margin: 4,
    },

    direction: {
        direction: 'rtl',
        width: 150,
        height: 40
    },

    fontright: {
        fontFamily: 'iransans',
        textAlign: 'right',
        marginRight: 10,
        width: 100
    },
    fontleft: {
        fontFamily: 'iransans',
        textAlign: 'right',
        marginLeft: 10
    }

    ,
    center: {

        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'

    }


}));

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    border: {
        fontFamily: 'iransans',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 10,
        fontSize: 5,
        display: 'flex',
        marginBottom: 0,
        color: 'rgba(0, 0, 0, 0.54)'

    },


});

const DialogTitle = withStyles(styles)((props) => {
    const {children, classes, onClose, ...other} = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h8">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon/>
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});


const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(1),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);


function toPersianNumCut(num, dontTrim) {

    if (num === '')
        return ''


    num = num.split("/")
    num = num[1] + "/" + num[2]

    var i = 0,

        dontTrim = dontTrim || false,

        num = dontTrim ? num.toString() : num.toString().trim(),
        len = num.length,

        res = '',
        pos,

        persianNumbers = typeof persianNumber == 'undefined' ?
            ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] :
            persianNumbers;

    for (; i < len; i++)
        if ((pos = persianNumbers[num.charAt(i)]))
            res += pos;
        else
            res += num.charAt(i);

    return res;
};


function toPersianNum(num, dontTrim) {

    var i = 0,

        dontTrim = dontTrim || false,

        num = dontTrim ? num.toString() : num.toString().trim(),
        len = num.length,

        res = '',
        pos,

        persianNumbers = typeof persianNumber == 'undefined' ?
            ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] :
            persianNumbers;

    for (; i < len; i++)
        if ((pos = persianNumbers[num.charAt(i)]))
            res += pos;
        else
            res += num.charAt(i);

    return res;
};

const ProductListItem2 = (props) => {

    debugger;
    const {
        id,
        image,
        name,
        tasviename,
        contactt, NameFamily,
        startdate,
        enddate,
        Night,
        Day,
        Cancel,
        contacttmobile,
        Delivery, Status,
        Possibility
    } = props.product;
    const key = props.keyItem
    // console.log(props)
    const [open, setOpen] = React.useState(false);
    const [delivery, setDelivery] = React.useState(Delivery);
    const [cancel, setCancel] = React.useState(Cancel);
    const [canceltext, setCanceltext] = React.useState('');
    const [possibility, setPossibility] = React.useState(Possibility);
    const [dialogclose, setDialogclose] = React.useState(false);
    const [loader, setLoader] = React.useState(false);
    const [newstatus, setNewstatus] = React.useState(false);
    const [menuState, setMenuState] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(undefined);

    useEffect(() => {
        // props.getposition(id);


        if (Status === 1) {
            setNewstatus(false);
        }

        if (Status === 2) {
            setNewstatus(true);
        }


        if (Cancel === true) {
            setCanceltext('(کنسل شده)');
        } else {
            setCanceltext('');

        }


    }, []);

    const options = [
        'ویرایش',
        'حذف',
    ];


    const opencalendar = () => {

        //alert("as");
        setOpen(!open);

    };

    const handleClose = () => {
        setOpen(false);
    };


    const onClickcheck = () => {
        // setDelivery(!Delivery)
        // Delivery = !Delivery ;
        setDelivery(!delivery);
        props.check(key, !delivery);

    };

    const onClickyes = () => {


        setLoader(true);
        setDialogclose(false);


        deletereserve(id)
            .then((response) => {
                if (response.data.errorCode === 0) {

                    setLoader(false);
                    setDialogclose(false);
                    props.delete(props.product);


                }
            })
            .catch((error) => {
                debugger;

            });


        // var delayInMilliseconds = 2000; //1 second
        //
        // setTimeout(function () {
        //     //your code to be executed after 1 second
        //     setLoader(false);
        //
        // }, delayInMilliseconds);


    };
    const onClickcancel = () => {

        setDialogclose(false);


    };

    const gotoedit = () => {
        props.getposition(id);
        props.push('/app/reserves/edit/' + id);


    };


    const onContactOptionSelect = () => {
        setMenuState(true);
    };
    const ondelete = () => {
        setDialogclose(true);
    };
    const onclosemenue = () => {
        setMenuState(false);
    };


    //  const getComponent = () => {
    //     switch (cancel) {
    //         case true:
    //             return <div ref={elementRef} className={classes.available} style={{
    //                 pointerEvents: 'none',
    //                 opacity: '0.4'
    //             }} onClick={onClick}
    //             >
    //
    //                 <div className={classes.availableday}>{toPersianNum(props.list.Day)}</div>
    //
    //
    //             </div>
    //
    //
    //         case false:
    //             return <div ref={elementRef} className={classes.available} onClick={onClick}
    //                         onMouseOver={() => props.hover()}
    //             >
    //
    //                 <div className={classes.availableday}>{toPersianNum(props.list.Day)}</div>
    //
    //                 <div className={classes.availableprice}>{toPersianNum(props.list.Price)}</div>
    //
    //
    //             </div>
    //
    //         case 2:
    //             return <div ref={elementRef} className={classes.availableselected} onClick={onClick}
    //                         onMouseOver={() => props.hover()}
    //             >
    //
    //                 <div className={classes.availabledayselected}>{toPersianNum(props.list.Day)}</div>
    //
    //                 <div className={classes.availablepriceselected}>{toPersianNum(props.list.Price)}</div>
    //
    //
    //             </div>
    //
    //         case 3:
    //             return <div ref={elementRef} className={classes.mainreserve} onClick={onClick}
    //                         onMouseOver={() => props.hover()}
    //             >
    //                 {props.list.ReserveId === 0 ?
    //
    //                     null
    //                     :
    //                     null
    //                     // <div style={{position: 'absolute',top:'70%', fontFamily: 'iransans', fontWeight: 'bold', color: '#fff'}}>
    //                     //     ر
    //                     // </div>
    //
    //
    //                 }
    //
    //
    //                 <div className={classes.availabledayselected}>{toPersianNum(props.list.Day)}</div>
    //
    //
    //
    //                  {props.list.ReserveId === 0 ?
    //
    //                      <div className={classes.availablepriceselected}>{toPersianNum(props.list.Price)}</div>
    //
    //                      :
    //                     <div className={classes.availablepriceselected} style={{fontSize:8}}>{props.list.Name}</div>
    //                  }
    //
    //             </div>
    //
    //
    //     }
    //
    // };


    return (
        <div elevation={2} className={` tr-${id}`}
             style={{marginBottom: 10, width: '100%', position: 'relative'}}>


            <Paper className="reserve_item" style={{paddingRight: 15, position: 'relative'}}>

                <div style={{
                    textAlign: 'left', display: 'flex', flexDirection: 'row-reverse', justifyContent: 'space-between',
                    alignItems: 'center',
                }}>
                    {/*<IconButton className="icon-btn p-2" style={{marginTop: 5}}*/}
                    {/*            onClick={onContactOptionSelect}>*/}
                    {/*    <i className="zmdi zmdi-more-vert"/>*/}
                    {/*</IconButton>*/}

                    {/*<div style={{textAlign: 'right'}}>*/}
                    {/*    <Menu id={`simple-menu-${key}`}*/}
                    {/*          anchorEl={anchorEl}*/}
                    {/*          open={menuState}*/}
                    {/*          onClose={onclosemenue}*/}
                    {/*          anchorOrigin={{*/}
                    {/*              vertical: "top",*/}
                    {/*              horizontal: "right",*/}
                    {/*          }}*/}
                    {/*          transformOrigin={{*/}
                    {/*              vertical: "top",*/}
                    {/*              horizontal: "right",*/}
                    {/*          }}*/}
                    {/*          MenuListProps={{*/}
                    {/*              style: {*/}
                    {/*                  width: 100,*/}
                    {/*              },*/}
                    {/*          }}>*/}
                    {/*        {options.map(option =>*/}
                    {/*            <MenuItem style={{fontFamily: 'iransans'}} key={option} onClick={() => {*/}
                    {/*                if (option === 'ویرایش') {*/}

                    {/*                } else {*/}
                    {/*                    ondelete();*/}
                    {/*                    onclosemenue()*/}
                    {/*                }*/}
                    {/*            }*/}
                    {/*            }>*/}
                    {/*                {option}*/}
                    {/*            </MenuItem>,*/}
                    {/*        )}*/}
                    {/*    </Menu>*/}


                    {/*</div>*/}

                    {/*<div style={{borderWidth:1,borderRadius:10 , padding:5,borderStyle:'solid',borderColor:'black'}}>*/}

                    {/*    <div>*/}
                    {/*        */}
                    {/*    </div>*/}

                    {/*    <div>armin</div>*/}

                    {/*</div>*/}

                    {/*<div style={{marginTop:10,marginLeft:10}} >*/}
                    {/*    <div onClick={()=>  ondelete()} style={{*/}
                    {/*        cursor: 'pointer',*/}
                    {/*        display: 'flex',*/}
                    {/*        justifyContent: 'center',*/}
                    {/*        alignItems: 'center',*/}
                    {/*        width: 40,*/}
                    {/*        height: 40,*/}

                    {/*        borderRadius: '50%',*/}
                    {/*        borderWidth: '0.1em',*/}
                    {/*        border: 'solid',*/}
                    {/*        borderColor: '#dadada'*/}
                    {/*    }}>*/}
                    {/*        <div style={{margin: '0 auto'}}>*/}
                    {/*            <img src={cancell} style={{width: 20, height: 20}}></img>*/}
                    {/*        </div>*/}

                    {/*    </div>*/}

                    {/*</div>*/}


                </div>

                <div className="row d-none d-lg-block d-xl-block align-items-sm-center">
                    <div className="col-xl-3 col-lg-4 col-md-3 col-3">
                        <div className="card-header border-0 p-0">
                            <div className="card-image">
                                <div className="grid-thumb-equal" style={{paddingBottom: '50%'}}>
                <span className="grid-thumb-cover jr-link">
                  <img style={{borderRadius: 4}} className="img-fluid object-cover" src={addressimagehomessize(image)}
                       alt="..."/>
                </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-6 col-lg-5 col-md-6 col-6">
                        <div className="card-body" style={{paddingRight: 15, paddingLeft: 15, fontWeight: 'bold'}}>
                            <div className="product-details">
                                <h3 className="card-title fw-regular iran-font"

                                    style={{fontWeight: 'bold'}}>{toPersianNum(name)} {canceltext}
                                    {/*<small className="text-grey text-darken-2">{', ' + enddate}</small>*/}
                                </h3>
                                {/*<div>*/}

                                {/*{name}*/}

                                {/*</div>*/}

                                <div style={{marginTop: 7}} className="d-flex ">

                                    {newstatus ?

                                        <h3 className="card-title iran-font">

                                            از
                                            تاریخ {Day} {toPersianNum(startdate)} توسط {NameFamily} ({toPersianNum(Night)} شب
                                            )
                                        </h3>


                                        :


                                        <h3 className="card-title iran-font">

                                            از
                                            تاریخ {Day} {toPersianNum(startdate)} توسط {contactt} ({toPersianNum(Night)} شب
                                            )
                                        </h3>

                                    }


                                    {/*<h5 className="text-muted px-2">*/}
                                    {/*<del>{startdate}</del>*/}
                                    {/*</h5>*/}
                                    {/*<h5 className="text-success">{startdate} off</h5>*/}
                                </div>
                                {/*<div className="d-flex ">*/}
                                {/*    <h3 className="card-title iran-font">*/}

                                {/*        تسویه با {tasviename} {toPersianNum(contacttmobile)}*/}

                                {/*    </h3>*/}


                                {/*    /!*{Delivery ?*!/*/}

                                {/*    /!*    :*!/*/}

                                {/*    /!*}*!/*/}
                                {/*    /!*<h5 className="text-muted px-2">*!/*/}
                                {/*    /!*<del>{startdate}</del>*!/*/}
                                {/*    /!*</h5>*!/*/}
                                {/*    /!*<h5 className="text-success">{startdate} off</h5>*!/*/}
                                {/*</div>*/}
                                <div className="d-flex align-items-center">
                                    <div style={{marginleft: 15, marginTop: 7}} className="iran-font font-weight-bold">

                                        وضعیت تحویل
                                    </div>

                                    {/*<Switch*/}
                                    {/*    checked={switchh}*/}
                                    {/*    onChange={handleChangeswitch}*/}
                                    {/*    name="checkedA"*/}
                                    {/*    inputProps={{'aria-label': 'secondary checkbox'}}*/}
                                    {/*/>*/}
                                    <Switch
                                        onChange={onClickcheck}
                                        checked={delivery}
                                        name="checkedA"
                                        inputProps={{'aria-label': 'secondary checkbox'}}
                                    />

                                    {/*<h5 className="text-muted px-2">*/}
                                    {/*<del>{startdate}</del>*/}
                                    {/*</h5>*/}
                                    {/*<h5 className="text-success">{startdate} off</h5>*/}
                                </div>
                                {/*<div className="d-flex flex-row " style={{height: 25}}>*/}
                                {/*<StarRatingComponent*/}
                                {/*name=""*/}
                                {/*value={rating}*/}
                                {/*starCount={5}*/}
                                {/*editing={false}/>*/}
                                {/*<p className="ml-2">{startdate}</p>*/}
                                {/*</div>*/}
                                {/*<p>{contactt}</p>*/}
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-3 col-lg-3 col-md-3 col-3 "
                         style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                        <div className="card-footer border-0 text-left bg-white">
                            <div className="cart-btn mb-2"
                                 style={{display: 'flex', flexDirection: 'column', marginTop: 30}}>


                                {newstatus ?
                                    <div style={{marginLeft: 10}}>
                                        {cancel ?
                                            <Button variant="contained"
                                                    className=" text-white iran-font"
                                                    style={{
                                                        background: '#bab1b1',
                                                        width: '100%',
                                                        marginLeft: 10, padding: 5,
                                                        height: 40,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'iransans',
                                                        fontSize: 15
                                                    }}>
                                                منتظر تایید
                                            </Button>
                                            :
                                            <Button onClick={gotoedit} variant="contained"
                                                    className=" text-white iran-font"
                                                    style={{
                                                        background: '#f3c743',
                                                        width: '100%',
                                                        marginLeft: 10, padding: 5,
                                                        height: 40,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'iransans',
                                                        fontSize: 15
                                                    }}>
                                                منتظر تایید
                                            </Button>

                                        }
                                    </div>

                                    :

                                    // {getComponent()}
                                    <div style={{marginLeft: 10}}>
                                        {cancel ?
                                            <Button variant="contained"
                                                    className="text-white iran-font"
                                                    style={{
                                                        width: '100%',
                                                        height: 40,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'iransans',
                                                        fontSize: 13
                                                    }}>
                                                مشاهده
                                            </Button>
                                            :
                                            <Button onClick={gotoedit} variant="contained"
                                                    className="bg-primary text-white iran-font"
                                                    style={{
                                                        width: '100%',
                                                        height: 40,
                                                        fontWeight: 'bold',
                                                        fontFamily: 'iransans',
                                                        fontSize: 13
                                                    }}>
                                                مشاهده
                                            </Button>

                                        }
                                    </div>
                                }


                                {/*{newstatus ?*/}

                                {/*    <Button onClick={gotoedit} variant="contained"*/}
                                {/*            className=" text-white iran-font"*/}
                                {/*            style={{*/}
                                {/*                background: '#f3c743',*/}
                                {/*                width: '100%',*/}
                                {/*                marginLeft: 10, padding: 5,*/}
                                {/*                height: 40,*/}
                                {/*                fontWeight: 'bold',*/}
                                {/*                fontFamily: 'iransans',*/}
                                {/*                fontSize: 10*/}
                                {/*            }}>*/}
                                {/*        منتظر تایید*/}
                                {/*    </Button>*/}


                                {/*    :*/}


                                {/*    <Button onClick={gotoedit} variant="contained"*/}
                                {/*            className="bg-primary text-white iran-font"*/}
                                {/*            style={{width: '100%'}}>*/}

                                {/*        /!*<Link to={{*!/*/}
                                {/*        /!*pathname: '/app/reserves/edit/' + id*!/*/}
                                {/*        /!*}} style={{color: '#ffffff'}}>*!/*/}
                                {/*        /!**!/*/}
                                {/*        /!*</Link>*!/*/}
                                {/*        نمایش*/}

                                {/*    </Button>*/}

                                {/*}*/}


                                <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginTop: 10, color: '#2d5a10'
                                }}>
                                    <div hidden={!possibility}
                                         style={{fontSize: 15}}
                                         className="iran-font font-weight-bold ">
                                        احتمال تمدید
                                    </div>
                                </div>
                            </div>


                            {/*<div className="cart-btn mb-2">*/}
                            {/*<Button onClick={onClickdelete} variant="contained"*/}
                            {/*className="bg-primary text-white iran-font"*/}
                            {/*style={{width: 120}}>*/}
                            {/*حذف رزرو*/}
                            {/*</Button>*/}
                            {/*</div>*/}


                        </div>
                    </div>
                </div>

                <div className="row d-none align-items-sm-center">
                    <div className="col-xl-3 col-lg-4 col-md-3 col-3">
                        <div className="card-header border-0 p-0">
                            <div className="card-image">
                                <div className="grid-thumb-equal" style={{paddingBottom: '50%'}}>
                <span className="grid-thumb-cover jr-link">
                  <img style={{borderRadius: 4}} className="img-fluid object-cover" src={addressimagehomessize(image)}
                       alt="..."/>
                </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-6 col-lg-5 col-md-6 col-6">
                        <div className="card-body" style={{paddingRight: 15, paddingLeft: 15, fontWeight: 'bold'}}>
                            <div className="product-details">
                                <h3 className="card-title fw-regular iran-font"
                                    style={{fontWeight: 'bold'}}>{toPersianNum(name)} {canceltext}
                                    {/*<small className="text-grey text-darken-2">{', ' + enddate}</small>*/}
                                </h3>
                                {/*<div>*/}

                                {/*{name}*/}

                                {/*</div>*/}

                                <div style={{marginTop: 7}} className="d-flex ">
                                    <h3 style={{fontFamily: 'iransans', fontSize: 10}}>
                                        از تاریخ {toPersianNumCut(startdate)} تا {toPersianNumCut(enddate)} {contactt}
                                    </h3>
                                    {/*<h5 className="text-muted px-2">*/}
                                    {/*<del>{startdate}</del>*/}
                                    {/*</h5>*/}
                                    {/*<h5 className="text-success">{startdate} off</h5>*/}
                                </div>
                                {/*<div className="d-flex ">*/}
                                {/*    <h3 className="card-title iran-font">*/}

                                {/*        تسویه با {tasviename} {toPersianNum(contacttmobile)}*/}

                                {/*    </h3>*/}


                                {/*    /!*{Delivery ?*!/*/}

                                {/*    /!*    :*!/*/}

                                {/*    /!*}*!/*/}
                                {/*    /!*<h5 className="text-muted px-2">*!/*/}
                                {/*    /!*<del>{startdate}</del>*!/*/}
                                {/*    /!*</h5>*!/*/}
                                {/*    /!*<h5 className="text-success">{startdate} off</h5>*!/*/}
                                {/*</div>*/}
                                <div className="d-flex align-items-center">
                                    <div style={{marginleft: 15}} className="iran-font font-weight-bold">

                                        وضعیت تحویل
                                    </div>

                                    {/*<Switch*/}
                                    {/*    checked={switchh}*/}
                                    {/*    onChange={handleChangeswitch}*/}
                                    {/*    name="checkedA"*/}
                                    {/*    inputProps={{'aria-label': 'secondary checkbox'}}*/}
                                    {/*/>*/}
                                    <Switch
                                        onChange={onClickcheck}
                                        checked={delivery}
                                        name="checkedA"
                                        inputProps={{'aria-label': 'secondary checkbox'}}
                                    />

                                    {/*<h5 className="text-muted px-2">*/}
                                    {/*<del>{startdate}</del>*/}
                                    {/*</h5>*/}
                                    {/*<h5 className="text-success">{startdate} off</h5>*/}
                                </div>
                                {/*<div className="d-flex flex-row " style={{height: 25}}>*/}
                                {/*<StarRatingComponent*/}
                                {/*name=""*/}
                                {/*value={rating}*/}
                                {/*starCount={5}*/}
                                {/*editing={false}/>*/}
                                {/*<p className="ml-2">{startdate}</p>*/}
                                {/*</div>*/}
                                {/*<p>{contactt}</p>*/}
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-3 col-lg-3 col-md-3 col-3 " style={{textAlign: 'center'}}>
                        {/*<div className="card-footer border-0 text-left bg-white">*/}
                        {/*    <div className="cart-btn mb-2">*/}
                        {/*      */}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <Button onClick={gotoedit} variant="contained"
                                className="bg-primary text-white iran-font"
                                style={{width: '100%'}}>

                            {/*<Link to={{*/}
                            {/*pathname: '/app/reserves/edit/' + id*/}
                            {/*}} style={{color: '#ffffff'}}>*/}
                            {/**/}
                            {/*</Link>*/}
                            نمایش

                        </Button>


                    </div>
                </div>


                <div className="row d-lg-none align-items-sm-center" style={{padding: 5, cursor: 'pointer'}}>
                    <div className="d-flex col-3" style={{justifyContent: 'center', padding: 0, alignItems: 'center'}}>
                        <img style={{width: '100%', height: 110, objectFit: 'cover', borderRadius: 4}}
                             src={addressimagehomessize(image)} alt="..."/>
                    </div>
                    <div className="d-flex flex-column col-6">

                        <div style={{fontFamily: 'iransans', fontSize: 14, fontWeight: 'bold'}}>
                            {toPersianNum(name)} {canceltext}
                        </div>

                        <div style={{fontFamily: 'iransans', marginTop: 7, fontWeight: 'bold', fontSize: 14}}>
                            {toPersianNum(startdate)} تا {toPersianNum(enddate)} توسط {newstatus ? NameFamily : contactt}
                        </div>

                        <div className="d-flex align-items-center">
                            <div style={{marginleft: 15, fontSize: 12, marginTop: 7}}
                                 className="iran-font font-weight-bold">
                                وضعیت تحویل
                            </div>
                            <Switch
                                onChange={onClickcheck}
                                checked={delivery}
                                name="checkedA"
                                inputProps={{'aria-label': 'secondary checkbox'}}
                            />
                        </div>


                    </div>
                    <div className="d-flex col-3"
                         style={{justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>


                        {newstatus ?
                            <div style={{marginLeft: 10}}>
                                {cancel ?
                                    <Button variant="contained"
                                            className=" text-white iran-font"
                                            style={{
                                                background: '#bab1b1',
                                                width: '100%',
                                                marginLeft: 10, padding: 5,
                                                height: 40,
                                                fontWeight: 'bold',
                                                fontFamily: 'iransans',
                                                fontSize: 15
                                            }}>
                                        منتظر تایید
                                    </Button>
                                    :
                                    <Button onClick={gotoedit} variant="contained"
                                            className=" text-white iran-font"
                                            style={{
                                                background: '#f3c743',
                                                width: '100%',
                                                marginLeft: 10, padding: 5,
                                                height: 40,
                                                fontWeight: 'bold',
                                                fontFamily: 'iransans',
                                                fontSize: 15
                                            }}>
                                        منتظر تایید
                                    </Button>

                                }
                            </div>

                            :

                            // {getComponent()}
                            <div style={{marginLeft: 10}}>
                                {cancel ?
                                    <Button variant="contained"
                                            className="text-white iran-font"
                                            style={{
                                                width: '100%',
                                                height: 40,
                                                fontWeight: 'bold',
                                                fontFamily: 'iransans',
                                                fontSize: 13
                                            }}>
                                        مشاهده
                                    </Button>
                                    :
                                    <Button onClick={gotoedit} variant="contained"
                                            className="bg-primary text-white iran-font"
                                            style={{
                                                width: '100%',
                                                height: 40,
                                                fontWeight: 'bold',
                                                fontFamily: 'iransans',
                                                fontSize: 13
                                            }}>
                                        مشاهده
                                    </Button>

                                }
                            </div>
                        }


                    </div>

                    <div hidden={!possibility}
                         style={{
                             fontSize: 15,
                             marginTop: 8,
                             position: 'absolute',
                             left: 10,
                             bottom: 5,
                             color: '#2d5a10'
                         }}
                         className="iran-font font-weight-bold ">
                        احتمال تمدید
                    </div>

                </div>


            </Paper>


            <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                {/*<DialogTitle id="customized-dialog-title" onClose={handleClose}>*/}
                {/*ویرایش تقویم*/}
                {/*</DialogTitle>*/}
                <div style={{margin: 10, fontFamily: 'iransans', fontWeight: 'bold', fontSize: 17}}>
                    ویرایش تقویم
                </div>
                <DialogContent dividers>
                    {/*<Typography gutterBottom>*/}
                    {/*Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis*/}
                    {/*in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.*/}
                    {/*</Typography>*/}
                    {/*<Typography gutterBottom>*/}
                    {/*Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis*/}
                    {/*lacus vel augue laoreet rutrum faucibus dolor auctor.*/}
                    {/*</Typography>*/}
                    {/*<Typography gutterBottom>*/}
                    {/*Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel*/}
                    {/*scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus*/}
                    {/*auctor fringilla.*/}
                    {/*</Typography>*/}


                    {/*<div className="d-flex flex-column" style={{fontFamily:'iransans',fontSize:10}}>*/}

                    {/*<div>نوع ویرایش را انتخاب کنید:</div>*/}

                    {/*<div className="d-flex align-items-center" style={{marginTop:10}}>*/}

                    {/*<div className={classes.border} style={{width:'100%',height:30 ,marginLeft:5, flex: 1,display:'flex',flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>*/}

                    {/*<div style={{fontSize:8}}>تغییر قیمت ها</div>*/}


                    {/*</div>*/}

                    {/*<div className={classes.border} style={{width:'100%',height:30 ,marginRight:5, flex: 1,display:'flex',flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>*/}

                    {/*<div style={{fontSize:8}}>ثبت رزروهای شخصی</div>*/}

                    {/*</div>*/}


                    {/*</div>*/}

                    {/*</div>*/}


                    <Calendar2/>

                </DialogContent>
                {/*<DialogActions>*/}
                {/*<Button autoFocus onClick={handleClose} color="primary">*/}
                {/*Save changes*/}
                {/*</Button>*/}
                {/*</DialogActions>*/}
            </Dialog>


            {dialogclose ?

                <DialogClose open={true} title='حذف رزرو' body='آیا از حذف این رزرو اطمینان دارید؟' loader={loader}
                             yes={onClickyes} cancel={onClickcancel}/>

                :

                <DialogClose open={false} title='حذف رزرو' body='آیا از حذف این رزرو اطمینان دارید؟' loader={loader}
                             yes={onClickyes} cancel={onClickcancel}/>


            }


        </div>
    )
};

export default ProductListItem2;

